<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <app-status-page main></app-status-page>
    <app-search-fields main data-at-rsa-search-section></app-search-fields>
    <app-search-result-list main></app-search-result-list>
    <app-search-history main></app-search-history>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
